/*
    Autor: Gabriela Farias
*/
import React, { Component } from 'react';
import { IntlProvider, intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { flattenMessages } from '@utils/languageUtils';
import { getUserLang } from '@utils/localeUtils';
import ptBR from './i18n/ptBR';
import enUS from './i18n/enUs';
import esES from './i18n/esES';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ButtonFAB from '@components/ButtonFAB/ButtonFAB';
import CardFilters from '@components/CardFilters/CardFilters';
import GroupButtonGrid from '@components/GroupButtonGrid/GroupButtonGrid';
import DataTable from '@components/DataTable/DataTable';
import { withStyles } from '@material-ui/core';
import swal from '@sweetalert/with-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MuiThemeProvider } from '@material-ui/core/styles';
import iconAdd from '@images/icone_add.png';
import FilterUtil from '../../filterUtil';
import Loading from '@components/Loading/Loading';
import Cultivar from '@resources/Cultivar';
import { style, theme } from './Cultivares.styles';

let messages = { 'pt-BR': ptBR, 'en-US': enUS, 'es-ES': esES };

var { provider } = new IntlProvider({});

/*
    Tela de Listagem de Cultivares customizada
*/
class Cultivares extends Component {
  constructor(props) {
    super(props);

    const messagesLinguage = flattenMessages(messages[getUserLang()]);
    const detentor = messagesLinguage['cultivares.detentor'];
    const codigo = messagesLinguage['cultivares.codigo'];
    const descricao = messagesLinguage['cultivares.descricao'];
    const cultura = messagesLinguage['cultivares.cultura'];
    const situacao = messagesLinguage['cultivares.situacao'];
    const desejaExcluirCultivar = messagesLinguage['cultivares.desejaExcluirCultivar'];
    const nao = messagesLinguage['cultivares.nao'];
    const excluir = messagesLinguage['cultivares.excluir'];
    const excluindo = messagesLinguage['cultivares.excluindo'];
    const falhaAoExcluirCultivar = messagesLinguage['cultivares.falhaAoExcluirCultivar'];
    const cultivarRemovidoComSucesso = messagesLinguage['cultivares.cultivarRemovidoComSucesso'];
    const ativo = messagesLinguage['cultivares.ativo'];
    const inativo = messagesLinguage['cultivares.inativo'];

    const intlProvider = new IntlProvider({
      locale: getUserLang(),
      messages: {
        detentor,
        codigo,
        descricao,
        cultura,
        situacao,
        desejaExcluirCultivar,
        nao,
        excluir,
        excluindo,
        falhaAoExcluirCultivar,
        cultivarRemovidoComSucesso,
        ativo,
        inativo
      }
    });

    provider = intlProvider.getChildContext();

    this.state = {
      operationTypeString: [
        {
          label: provider.intl.formatMessage({ id: 'detentor' }),
          field: 'nmCultivar',
          type: 'string'
        },
        {
          label: provider.intl.formatMessage({ id: 'cultura' }),
          field: 'nmCultura',
          type: 'string'
        },
        {
          label: provider.intl.formatMessage({ id: 'situacao' }),
          field: 'situacao',
          type: 'enum',
          options: [
            {
              label: provider.intl.formatMessage({ id: 'ativo' }),
              field: 'Ativo',
              value: 'ativo'
            },
            {
              label: provider.intl.formatMessage({ id: 'inativo' }),
              field: 'Inativo',
              value: 'inativo'
            }
          ]
        }
      ],
      dataAppSync: [],
      dataInTable: [],
      head: [
        {
          field: 'nmCultivar',
          headerName: provider.intl.formatMessage({ id: 'detentor' }),
          col: 4
        },
        {
          field: 'nmCultura',
          headerName: provider.intl.formatMessage({ id: 'cultura' }),
          col: 3
        },
        {
          field: 'situacao',
          headerName: provider.intl.formatMessage({ id: 'situacao' }),
          col: 5
        }
      ],
      itemSelect: '',
      disabledEdit: true,
      disabledExcluir: true,
      loading: true
    };

    const title = 'cultivares.cultivares';
    if (this.props.itensState.name !== 'cultivares.cultivares') {
      this.props.dispatch({
        type: 'UPDATE_TOOLBAR',
        toolbar: (
          <IntlProvider locale={getUserLang()} messages={flattenMessages(messages[getUserLang()])}>
            <FormattedMessage id={title} />
          </IntlProvider>
        ),
        name: title
      });
    }

    this.onFilter = this.onFilter.bind(this);
    this.clickEditar = this.clickEditar.bind(this);
    this.clickAdicionar = this.clickAdicionar.bind(this);
    this.selectChange = this.selectChange.bind(this);
    this.onFilterChanged = this.onFilterChanged.bind(this);
    this.clickExcluir = this.clickExcluir.bind(this);
    this.atualizarRegistros = this.atualizarRegistros.bind(this);
  }

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount() {
    this.onFilter(this.props.chipData);
  }

  selectChange(select) {
    if (select) {
      this.setState({
        itemSelect: select,
        disabledEdit: false,
        disabledExcluir: select.idCliente === null
      });
    } else {
      this.setState({
        itemSelect: '',
        disabledEdit: true,
        disabledExcluir: true
      });
    }
  }

  onFilterChanged(dataChips) {
    this.setState({
      dataInTable: FilterUtil.applyFilters(this.state.dataAppSync, dataChips)
    });
  }

  onFilter(dataChips) {
    dataChips = dataChips || [];

    Cultivar.findAllCultivar()
      .then(query => {
        var data = query.data;

        data.forEach(doc => {
          doc.situacao =
            doc.stCultivar === 1
              ? provider.intl.formatMessage({ id: 'ativo' })
              : provider.intl.formatMessage({ id: 'inativo' });
          doc.nmCultura = doc.cultura.nmCultura;
        });

        this.setState({
          dataInTable: FilterUtil.applyFilters(query.data, dataChips),
          loading: false,
          dataAppSync: query.data
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          dataAppSync: []
        });
      });
  }

  clickAdicionar() {
    this.props.history.push('/app/cultivar/novo');
  }

  clickEditar() {
    this.props.history.push('/app/cultivar/editar/' + this.state.itemSelect.idCultivar);
  }

  clickExcluir() {
    swal({
      title: provider.intl.formatMessage({ id: 'desejaExcluirCultivar' }),
      icon: 'warning',
      closeOnClickOutside: false,
      closeOnEsc: false,
      buttons: {
        cancel: {
          text: provider.intl.formatMessage({ id: 'nao' }),
          value: false,
          visible: true,
          closeModal: true,
          className: 'swal2-cancel'
        },
        confirm: {
          text: provider.intl.formatMessage({ id: 'excluir' }),
          value: true,
          visible: true,
          closeModal: false,
          className: 'swal2-confirm'
        }
      }
    }).then(willDelete => {
      if (willDelete) {
        swal.stopLoading();
        swal(
          <div>
            <MuiThemeProvider theme={theme}>
              <CircularProgress />
            </MuiThemeProvider>
          </div>,
          {
            buttons: false,
            closeOnClickOutside: false,
            title: provider.intl.formatMessage({ id: 'excluindo' })
          }
        );
        Cultivar.deleteCultivarById(this.state.itemSelect.idCultivar)
          .then(() => {
            swal(
              provider.intl.formatMessage({
                id: 'cultivarRemovidoComSucesso'
              }),
              {
                icon: 'success',
                buttons: {
                  confirm: {
                    text: 'Ok',
                    value: true,
                    visible: true,
                    closeModal: true,
                    className: 'swal2-Ok'
                  }
                }
              }
            ).then(() => {
              this.atualizarRegistros(this.state.itemSelect.idCultivar);
            });
          })
          .catch(error => {
            swal(provider.intl.formatMessage({ id: 'falhaAoExcluirCultivar' }), {
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Ok',
                  value: true,
                  visible: true,
                  closeModal: true,
                  className: 'swal2-error'
                }
              }
            });
          });
      }
    });
  }

  atualizarRegistros(dataCultivares) {
    var ajusteRegistros = this.state.dataAppSync.filter(data => {
      return dataCultivares !== data.idCultivar;
    });

    this.setState({
      dataAppSync: ajusteRegistros,
      dataInTable: ajusteRegistros
    });

    this.onFilterChanged(this.props.chipData);
  }

  render() {
    const pagination = {
      length: this.state.dataInTable.length,
      page: 0
    };

    return (
      <IntlProvider locale={getUserLang()} messages={flattenMessages(messages[getUserLang()])}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            overflowY: 'scroll'
          }}
        >
          {this.state.loading && <Loading />}
          <CardFilters
            filtros={this.state.operationTypeString}
            usePaddings={false}
            onFilter={this.onFilter}
            onFilterChanged={this.onFilterChanged}
            viewKey='cultivar'
          />
          <GroupButtonGrid
            showAdd={false}
            showEdit={true}
            showDelete={true}
            disableEdit={this.state.disabledEdit}
            disableDelete={this.state.disabledExcluir}
            onClickDelete={this.clickExcluir}
            onClickEdit={this.clickEditar}
          />

          <div
            style={{
              marginTop: 30,
              marginBottom: 15,
              display: 'contents',
              width: '100%',
              flex: 1
            }}
          >
            <DataTable
              data={this.state.dataInTable}
              columns={this.state.head}
              selectChange={this.selectChange}
              showPagination={true}
              pagination={pagination}
            />
          </div>

          <ButtonFAB icon={iconAdd} positionDefault={true} onClick={this.clickAdicionar} />
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'cultivar';
  })[0].content
});

Cultivares.propTypes = {
  intl: intlShape.isRequired
};

let enhaced = injectIntl(withStyles(style)(Cultivares));
export default withRouter(connect(mapStateToProps)(enhaced));
